/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {TypePrice} from './TypePrice';
import {Currency} from './Currency';

export interface ProductPrice {
  id: number;
  priceType: TypePrice;
  priceTypeId?: number;
  price: number;
  updatedAt: Date;
  currency: Currency;
  currencyId?: number;
}
